import type { FunctionalComponent } from 'preact';
import { useCallback } from 'preact/hooks';
import { useStore } from '../store';
import { createSponsorLead } from '../api/client';

/**
 * Yes/No sponsor lead prompt rendered on top of the video player (not a separate page overlay).
 */
export const SponsorLeadConsentPanel: FunctionalComponent = () => {
    const { state, dispatch } = useStore();
    const current = state.sponsorLeadQueue[0];

    const submit = useCallback(
        (interested: boolean) => {
            if (!current || !state.event) return;
            dispatch({
                type: 'SET_SPONSOR_LEAD_CONSENT',
                event_sponsor_id: current.eventSponsorId,
                interested,
            });
            createSponsorLead({
                eventSponsorId: current.eventSponsorId,
                eventId: state.event._id,
                interested,
                correlationId: state.viewCorrelationId,
                discountId: undefined,
                name: state.contact.name,
                email: state.contact.email,
                phone: state.contact.phone,
            }).catch(() => {});
            dispatch({ type: 'POP_SPONSOR_LEAD_QUEUE' });
        },
        [current, dispatch, state.contact, state.event, state.viewCorrelationId],
    );

    if (!current) return null;

    const sponsorName = current.sponsorName || 'Sponsor';

    return (
        <div class="mw-lead-panel" onClick={e => e.stopPropagation()}>
            <div class="mw-lead-panel-inner">
                <div class="mw-lead-badge">
                    <span>Sponsor Offer</span>
                </div>
                <h3 class="mw-lead-title">Are you interested in {sponsorName}'s offering?</h3>
                <p class="mw-lead-subtext">
                    {sponsorName} will reach out with details you provide. By accepting you consent to be contacted
                    by {sponsorName} via electronic means.
                </p>
                <button type="button" class="mw-btn mw-btn--primary mw-lead-yes" onClick={() => submit(true)}>
                    Yes
                </button>
                <button type="button" class="mw-btn mw-btn--outline mw-lead-no" onClick={() => submit(false)}>
                    No
                </button>
            </div>
        </div>
    );
};
